const appConfig =
  typeof window !== "undefined" && window.appConfig ? window.appConfig : {};

const config = {  debug: true,
  tokenStorageName: "ocppAccessToken",
  credentialsTokenStorage: "ocppCredentialToken",
  credentialsRefreshTokenStorage: "ocppCredentialsRefreshToken",
  tokenExpireGapMin: 20,
  tokenCheckInterval: 1000 * 60 * 5,
  apiCheckInterval: 5000,
  clientSecret: process.env.OAUTH2_CLIENT_SECRET,
  ...appConfig,
};

export default config;
